// Redux
import { useSelector, useDispatch } from 'react-redux';
// Components
import Card from '../../Components/Card';
import InternalContainer from '../../Components/InternalContainer';
import Pagination from '../../Components/Pagination';
import SummarySearch from '../../Components/SummarySearch';
import FiltersPatents from '../../Components/FiltersPatents';
import { LoadingSkeleton } from '../../Components/LoadingSkeleton';
import { SkeletonTypes } from '../../Components/LoadingSkeleton/types';
// Slices
import { setPagePatents } from '../../app/features/patentsSlice';
// Hooks
import { usePatents } from '../../hooks/usePatents';
import { useScrollToTop } from '../../hooks/useScrollToTop';
// Styles
import './Patents.css';
import { FavoriteCategory } from '../FavoriteDetail/types';
import { useAuth } from '../../hooks/useAuth';
// Translate
import { useTranslation } from 'react-i18next';

const PatentsPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isAuth } = useAuth();
  // Hooks
  const { getPatentsDataSocket } = usePatents();
  const { handleScrollToTop } = useScrollToTop();

  // Slices
  const {
    patents,
    filters,
    pagePatents,
    isLoadingPatents,
    totalPatents,
    queryPatents,
  } = useSelector((state) => state.patents);

  // Pagination
  const itemsPerPage = 10;
  const indexOfLastItem = pagePatents * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = patents.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(totalPatents / itemsPerPage);

  const handlePageChange = (newPage) => {
    handleScrollToTop(0);
    if (newPage > pagePatents) {
      if (
        pagePatents < totalPages ||
        (Math.ceil(patents?.length / itemsPerPage) > 1 && totalPages === 0)
      ) {
        dispatch(setPagePatents(newPage));
        if (newPage >= Math.ceil(patents?.length / itemsPerPage) - 1) {
          getPatentsDataSocket(
            filters.queryFetched,
            filters.pageFetched + 1,
            filters.startYearFetched,
            filters.endYearFetched,
            filters.sourcesPatentsFetched
          );
        }
      }
    } else {
      if (pagePatents > 1) {
        dispatch(setPagePatents(newPage));
      }
    }
  };

  return (
    <>
      {isLoadingPatents && (
        <main className='patents-content'>
          <InternalContainer>
            <section className='results'>
              {Array.from({ length: 10 }).map((_, i) => (
                <LoadingSkeleton key={i} type={SkeletonTypes.LIBRARY_CARD} />
              ))}
            </section>
          </InternalContainer>
        </main>
      )}

      {!isLoadingPatents && patents?.length > 0 && (
        <main className='patents-content'>
          <InternalContainer>
            <div className='metasearchLibraryContainer__info'>
              <div className='summaryContainer'>
                <SummarySearch total={totalPatents} />
                <FiltersPatents />
              </div>
            </div>

            <section>
              <div className='results'>
                {currentItems?.map((patent, i) => (
                  <Card
                    key={i}
                    title={patent.title}
                    authors={[patent.authors]}
                    abstract={patent.abstract}
                    publication_date={patent.date}
                    url={patent.url}
                    type={t('Patent')}
                    resource_origin={
                      patent.source_code
                        ? patent.source_code.replace('_', ' ')
                        : 'No data source'
                    }
                    peer_reviewed={patent.peer_reviewed}
                    favoriteCategory={FavoriteCategory.PATENTS}
                    showFavoriteButton={isAuth()}
                  />
                ))}
              </div>

              <Pagination
                pageShowed={pagePatents}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            </section>
          </InternalContainer>
        </main>
      )}

      {!isLoadingPatents && totalPatents === 0 && queryPatents.length === 0 && (
        <main className='noDataContainerPatents'>
          <InternalContainer className='no-data'>
            <p>{t('Please enter a search term')}</p>
          </InternalContainer>
        </main>
      )}

      {!isLoadingPatents &&
        patents?.length === 0 &&
        queryPatents.length > 0 && (
          <main className='noDataContainerPatents'>
            <InternalContainer className='no-data'>
              <p>{t('No data found')}</p>
            </InternalContainer>
          </main>
        )}
    </>
  );
};

export default PatentsPage;
